var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircusTent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.248 4.78101L15.92 2.68101C16.0813 2.5886 16.178 2.41431 16.1711 2.22854C16.1642 2.04276 16.0547 1.87616 15.887 1.79601L12.215 0.0490138C12.0602 -0.0247365 11.8783 -0.0139732 11.7332 0.0775291C11.5882 0.169031 11.5001 0.328502 11.5 0.500014V4.34601C11.4997 4.52438 11.5944 4.68941 11.7486 4.77908C11.9028 4.86875 12.0931 4.86949 12.248 4.78101Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.24599 10.5H17.755C17.8599 10.4998 17.9536 10.4342 17.9895 10.3357C18.0255 10.2372 17.9961 10.1267 17.916 10.059L12.323 5.32597C12.1366 5.1682 11.8634 5.1682 11.677 5.32597L6.08399 10.059C6.00371 10.1268 5.9744 10.2375 6.01063 10.3362C6.04686 10.4348 6.14091 10.5003 6.24599 10.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.853 22.478C21.553 20.362 19.403 15.978 19.053 12.227C19.041 12.0968 18.9307 11.9979 18.8 12H5.2C5.07081 11.9999 4.96288 12.0983 4.951 12.227C4.598 15.978 2.445 20.363 1.151 22.478C0.962479 22.786 0.954691 23.1717 1.13062 23.4871C1.30655 23.8025 1.63886 23.9985 2 24H7.2C7.38523 24 7.55531 23.8977 7.642 23.734L11.559 16.334C11.6456 16.1702 11.8157 16.0677 12.001 16.0677C12.1863 16.0677 12.3564 16.1702 12.443 16.334L16.36 23.734C16.4463 23.897 16.6155 23.9993 16.8 24H22C22.3618 24 22.6955 23.8045 22.8724 23.4889C23.0493 23.1732 23.0419 22.7866 22.853 22.478Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircusTent);
export default __webpack_public_path__ + "static/media/circusTent.5867b9d3.svg";
export { ForwardRef as ReactComponent };